

export const Constants = {
  COMPONENT_OPTIONS_KEY: "nuxtI18n",
  STRATEGIES: {"PREFIX":"prefix","PREFIX_EXCEPT_DEFAULT":"prefix_except_default","PREFIX_AND_DEFAULT":"prefix_and_default","NO_PREFIX":"no_prefix"},
  REDIRECT_ON_OPTIONS: {"ALL":"all","ROOT":"root","NO_PREFIX":"no prefix"},
}
export const nuxtOptions = {
  isUniversalMode: true,
  trailingSlash: true,
}
export const options = {
  vueI18n: {"fallbackLanguage":"de","messages":{"de":{"lang":"Deutsch","page_protected":"Diese Seite ist Passwortgeschützt.","password":"Passwort","login":"Einloggen","countdown":"Hier entsteht etwas Neues in","back":"zurück","internal_link_to":"Interner Link auf","external_link_to":"Externer Link auf","link_to":"Link auf","back_to_overview":"Zurück zur Übersicht"}}},
  vueI18nLoader: true,
  locales: [{"code":"de","name":"Deutsch","iso":"de-CH"}],
  defaultLocale: "de",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  defaultLocaleRouteNameSuffix: "default",
  sortRoutes: true,
  strategy: "prefix_except_default",
  lazy: false,
  langDir: null,
  rootRedirect: null,
  detectBrowserLanguage: false,
  differentDomains: false,
  baseUrl: "https://echt.ch",
  vuex: {"moduleName":"i18n","syncRouteParams":true},
  parsePages: false,
  pages: {},
  skipSettingLocaleOnNavigate: false,
  onBeforeLanguageSwitch: () => {},
  onLanguageSwitched: () => null,
  seo: false,
  normalizedLocales: [{"code":"de","name":"Deutsch","iso":"de-CH"}],
  localeCodes: ["de"],
  additionalMessages: [],
}

export const localeMessages = {}
